import React, { useState } from 'react';
import classNames from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';

import { ReactComponent as WhiteSearch } from '../../assets/icons/white-search.svg';
import { ReactComponent as GreenChecker } from '../../assets/icons/green_checker.svg';

import { formatNumber } from '../../utils/react';
import { Button, EButtonType, KitIcons } from '@repo/apg-ui';
import styles from './CampaignDetailRow.module.scss';
import { useNavigate } from 'react-router';
import parse from 'html-react-parser';
import { numberWithSpaces } from '../../utils/numbers';
import { formatDate } from '../../utils/product';

export interface Props {
  product: any;
  index: any;
  moreContent?: any;
  selectOrDeselect?: any;
  basketId?: string;
  campaignId: string;
  history: any;
  intl: any;
}

const CampaignDetailRow = ({
  product,
  selectOrDeselect,
  basketId,
  index,
  moreContent,
  campaignId,
  history,
  intl,
}: Props) => {
  const [expanded, expand] = useState(false);

  const icons = KitIcons.productIcons;
  const navigate = useNavigate();

  const isDigiflex = product.producttype === 'digital';
  const performanceValue = product.performancevalue;
  const performanceType = product.performancetype;

  const basketTimeslot = product.timeslotsinformation
    ? product.timeslotsinformation.find((t) => t.timeslot === product.baskettimeslot)
    : null;
  const basketTimeslotName = basketTimeslot ? basketTimeslot.name : product.baskettimeslot;

  const getPerformanceLabel = (type: string) => {
    switch (performanceType) {
      case 1:
        return intl.formatMessage({
          id: 'ec.general.performanceType1',
          defaultMessage: 'Kontaktchancen pro Woche',
        });
      case 2:
        return intl.formatMessage({
          id: 'ec.general.performanceType2',
          defaultMessage: 'Fahrgastzahlen pro Woche',
        });
      default:
        return '';
    }
  };

  return (
    <div
      className={classNames(styles.campaignDetailRowView, {
        expanded: expanded,
        'product-row': true,
      })}
    >
      <div className={styles.campaignDetailRowColumn}>
        {product.productphotopath ? (
          <div className='product-row-image'>
            <Button
              className='search-box d-flex justify-content-center align-items-center'
              buttonType={EButtonType.BasicLink}
              onClick={() => {
                if (product.producttype !== 'digital')
                  navigate({
                    search: `?modalContent=product&urn=${product.producturn}&isHideActions=true`,
                  });
              }}
            >
              <WhiteSearch />
            </Button>

            <div className='code-product'>{product.mediainfo.nummer}</div>

            <img alt='Product' src={product.productphotopath + '&resolution=thumbnail'} />
          </div>
        ) : (
          <div className='product-row-image no-img' />
        )}
      </div>

      <div className={styles.campaignDetailRowColumn}>
        <div className='product-row-column-first align-items-start justify-content-center product-icon'>
          {KitIcons.getProductIcon(product)}
          {product.producttype === 'digital' && (
            <div className='column-title' style={{ marginBottom: '5px' }}>
              <FormattedMessage id='ec.modals.resultList.columnTitles.screens' defaultMessage='Anz. Screens' />
            </div>
          )}
          {(product.producttype === 'analog' || product.producttype === 'traffic') &&
            product.mediacount &&
            product.mediacount > 0 && (
              <div className='column-title' style={{ marginBottom: '5px' }}>
                <FormattedMessage id='ec.modals.resultList.columnTitles.flaschen' defaultMessage='Anz. Flächen' />
              </div>
            )}

          {product.mediacount && product.mediacount > 0 && (
            <p
              className='mb-0 w-100 align-content-center'
              style={{ textAlign: 'center' }}
            >{`${product.mediacount} `}</p>
          )}
        </div>
      </div>

      <div className={styles.campaignDetailRowColumn}>
        <div className='product-row-column-first flex-column product-address'>
          {product?.address && parse(product.address)}
          {(!isDigiflex || product.baskettimeslot === 1) && performanceValue > 0 && (
            <div className='w-100'>
              <b>{getPerformanceLabel(performanceType)}</b>
              <span>: {numberWithSpaces(performanceValue)}</span>
            </div>
          )}
          <div className='w-100'>
            <Button
              className='fw-normal text-decoration-underline mt-0 text-start'
              buttonType={EButtonType.BasicLink}
              onClick={() => {
                navigate({
                  search: `?modalContent=map&lat=${product.latitude}&lng=${product.longitude}&urn=${product.producturn}`,
                });
              }}
            >
              <FormattedMessage id='ec.components.buttons.seeOnMap' defaultMessage='Auf Karte ansehen' />
            </Button>
          </div>
        </div>
      </div>

      <div className={styles.campaignDetailRowColumn}>
        <div className='product-row-column-first icon termin justify-content-center'>
          {isDigiflex && product.baskettimeslot && (
            <span className='d-flex' style={{ marginBottom: '10px' }}>
              {basketTimeslotName?.replace(/ /g, '\u00a0')}
            </span>
          )}
          <span className='d-flex'>
            <div className=''>
              <GreenChecker className='green-checker me-3' />
            </div>
            <div className='d-flex flex-column'>
              <span>
                <FormattedMessage
                  id='ec.general.daysAndSpotLength'
                  defaultMessage='{duration} Tage{spotLength}'
                  values={{
                    duration: product.basketduration,
                    spotLength: product.basketspotlength ? ', ' + product.basketspotlength + 's' : '',
                  }}
                />
              </span>
              <br />
              <span className='d-block'>
                {product.basketstartdate && formatDate(product.basketstartdate)}
                {' - '}
                <br />
                {product.basketenddate && formatDate(product.basketenddate)}
              </span>
            </div>
          </span>
        </div>
      </div>

      <div className={styles.campaignDetailRowColumn} onClick={() => expand(!expanded)}>
        <div className='w-100' style={{ paddingLeft: '10px' }}>
          {formatNumber(product.basketprice)}.-
        </div>
      </div>
    </div>
  );
};

export default injectIntl(CampaignDetailRow);
